module.exports = __webpack_public_path__ + "img/thank_2021_tip3_small.2dcd9263.png";